import { Button } from '@cropler/ui-kit';
import { Capacitor } from '@capacitor/core';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

import styles from './styles.module.scss';

import { downloadPhotoByUrl, shareImageMobileApp } from '../../utils/images';

const CardDownloadImage = ({ image }) => {
  return (
    <>
      {!Capacitor.isNativePlatform() ? (
        <Button
          className={styles.cardButton}
          type="secondary"
          size="large"
          icon={<CroplerIcon name="download" />}
          onClick={() => downloadPhotoByUrl({ url: image.url, urlName: image.url, takenAt: image.takenAt })}
        />
      ) : (
        <Button
          className={styles.cardButton}
          type="secondary"
          size="large"
          icon={<CroplerIcon name="share" />}
          onClick={() => shareImageMobileApp(image.url)}
        />
      )}
    </>
  );
};

export default CardDownloadImage;
